export default "/img_gauge-bar.png";